"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatComponent = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = __importStar(require("@chatui/core"));
const client_1 = require("./client");
require("@chatui/core/es/styles/index.less");
require("@chatui/core/dist/index.css");
const botAvatar = require('../resource/copilot-bot.png');
const me = {
    id: 'my_user_id',
    name: 'me'
};
const client = client_1.OpencuiClient.create({
    url: 'https://api-64b897ae0f50353c647ca60b.api-us.naturali.io/v1/en',
    user: me
});
function getAvatar(user) {
    return user.id === 'my_user_id' ? '//gw.alicdn.com/tfs/TB1DYHLwMHqK1RjSZFEXXcGMXXa-56-62.svg' : botAvatar;
}
function converMessage(copilotMsg) {
    switch (copilotMsg.messageType) {
        case client_1.MessageType.Text:
            return {
                type: 'text',
                content: { text: copilotMsg.text },
                position: copilotMsg.user.id === 'my_user_id' ? 'right' : 'left',
                user: { avatar: getAvatar(copilotMsg.user) }
            };
        case client_1.MessageType.Card:
            return {
                type: 'card',
                content: copilotMsg,
                position: copilotMsg.user.id === 'my_user_id' ? 'right' : 'left',
                user: { avatar: getAvatar(copilotMsg.user) }
            };
        default:
            return { type: 'text' };
    }
}
function ChatComponent(props) {
    // 消息列表
    const { messages, appendMsg, setTyping } = (0, core_1.useMessages)([]);
    // init session
    react_1.default.useEffect(() => {
        client.setUrl(props.botURL);
        // register context getter. for example, just pass current url as app state.
        if (props.contextGetter) {
            client.registerContextGetter(props.contextGetter);
        }
        client.connect().then(initMsgs => {
            for (const msg of initMsgs) {
                appendMsg(converMessage(msg));
            }
        }).catch(err => {
            console.log(err);
        });
    }, [props.botURL, appendMsg, props.contextGetter]);
    react_1.default.useEffect(() => {
        //  register action handler. 
        client.registerActionHandler(function (action) {
            if (action.url) {
                window.location.href = action.url;
            }
            else if (props.actionHandler) {
                props.actionHandler(action);
            }
            else {
                alert('action handler not found');
            }
        });
    }, [props.actionHandler]);
    function handleSend(type, val, extra) {
        if (type === 'text' && val.trim()) {
            appendMsg({
                type: 'text',
                content: { text: val },
                position: 'right',
                user: {
                    avatar: '//gw.alicdn.com/tfs/TB1DYHLwMHqK1RjSZFEXXcGMXXa-56-62.svg'
                }
            });
            setTyping(true);
            client.sendMessage({
                messageType: client_1.MessageType.Text,
                text: val,
                user: me
            }, undefined, undefined, extra).then(resps => {
                for (const msg of resps) {
                    appendMsg(converMessage(msg));
                }
            }).catch(err => {
                console.log(err);
            });
        }
    }
    function handleQuickReplyClick(text, extra) {
        handleSend('text', text, extra);
    }
    function renderMessageContent(msg) {
        const { type, content } = msg;
        const media = content.richMedia;
        switch (type) {
            case 'text':
                return react_1.default.createElement(core_1.Bubble, { content: content.text, style: { textAlign: 'left' } });
            case 'image':
                return (react_1.default.createElement(core_1.Bubble, { type: "image" },
                    react_1.default.createElement("img", { src: content.picUrl, alt: "" })));
            case 'card':
                return (react_1.default.createElement(core_1.Bubble, { type: "card", content: react_1.default.createElement("div", { style: { padding: '0 8px' } },
                        content.title && react_1.default.createElement("h3", { key: "title", style: {
                                textAlign: 'left',
                                margin: 4
                            } }, content.title),
                        content.text && react_1.default.createElement("pre", { key: "text", style: {
                                margin: 4,
                                textAlign: 'left',
                                width: '100%',
                                whiteSpace: 'pre-wrap',
                                wordBreak: 'normal',
                                overflowWrap: 'anywhere'
                            } }, content.text),
                        media && react_1.default.createElement("img", { key: "img", style: { maxWidth: '100%' }, src: media.fileURL, alt: media.altText }),
                        content.actionList && content.actionList.length ? react_1.default.createElement("div", { style: { display: 'flex', flexWrap: 'wrap', marginLeft: -4, marginRight: -4 } }, content.actionList.map((action, index) => {
                            return react_1.default.createElement(core_1.Button, { key: index, onClick: () => {
                                    switch (action.actionType) {
                                        case client_1.ActionType.reply:
                                            handleQuickReplyClick(action.text, action.actionParams);
                                            break;
                                        case client_1.ActionType.click:
                                            client.executeAction(action);
                                            break;
                                        default:
                                            alert('This action is not supported yet');
                                            break;
                                    }
                                }, color: "primary", style: { margin: 4 } }, action.text);
                        })) : '') }));
            default:
                return null;
        }
    }
    return (react_1.default.createElement("div", Object.assign({}, props, { style: Object.assign({ height: '100%' }, props.style), className: 'opencui-chat-container' + (props.className || '') }),
        react_1.default.createElement(core_1.default, { locale: 'en-US', navbar: { title: props.title || 'Copilot' }, messages: messages, renderMessageContent: renderMessageContent, onSend: handleSend, placeholder: 'Please enter...' })));
}
exports.ChatComponent = ChatComponent;
exports.default = ChatComponent;
